{
  "dirty": false,
  "raw": "d92fef27",
  "hash": "d92fef27",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "d92fef27",
  "semverString": null,
  "version": "1.0.0"
}